import { useNavigate } from "react-router-dom";
import { FormButton } from "../atoms";
type ErrorPageTemplateProps = {
  button1Click?: () => void;
  button2Click?: () => void;
  button1Label: string;
  button2Label: string;
  topText: React.ReactNode;
  bottomText: React.ReactNode;
  imageUrl?: string;
};
export function ErrorPageTemplate(props: ErrorPageTemplateProps) {
  const navigate = useNavigate();
  return (
    <div>
      <img src="/assets/images/logo.svg" style={{ cursor: "pointer" }} onClick={() => navigate("/")} />
      <div style={{ textAlign: "center", display: "flex", gap: "24px", alignItems: "center", flexDirection: "column" }}>
        <img src={props.imageUrl} />
        <div style={{ fontWeight: 500, fontSize: "60px", lineHeight: "78px" }}>{props.topText}</div>
        <div style={{ fontWeight: 400, fontSize: "18px", lineHeight: "30px" }}>{props.bottomText}</div>
        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          <FormButton variant="outlined" label={props.button1Label} onClick={props.button1Click} />
          <FormButton label={props.button2Label} onClick={props.button2Click} />
        </div>
      </div>
    </div>
  );
}

export default ErrorPageTemplate;
